<div
  *ngIf="formStatus$ | async as formStatus"
  class="comment-sender"
  id="containerElement"
>
  <div [ngClass]="{ visible: formStatus.error }" class="comment-sender__error">
    {{ "gallery.error" | translate }}

    <span (click)="closeErrorBlock()" class="close-button close-button_error">
      <fa-icon [icon]="['fas', 'times']"></fa-icon>
    </span>
  </div>

  <div [ngClass]="{ empty: isEmpty }" class="comment-sender__textarea">
    <textarea
      #message
      (focus)="resetAlert()"
      [disabled]="formStatus.loading"
      [placeholder]="placeholder"
      class="comment-sender__message"
      name="message"
    ></textarea>
  </div>
  <div class="sendler-button-container">
    <div class="block-btn-sender">
      <div
        *ngIf="isAllowCreateTask"
        [ngClass]="{
          'clip-container': true,
          active: isCheckedSetTaskMerch(),
          loaded: photos().length
        }"
      >
        <div>
          <fa-icon
            (click)="onClipClick()"
            [icon]="['fas', 'paperclip']"
            class="icon paperclip"
          ></fa-icon>
          <div *ngIf="photos().length" class="photo-length">
            {{ photos().length }}
          </div>
        </div>
      </div>
      <div
        *ngIf="isAllowCreateTask"
        [ngClass]="{ active: isCheckedSetTaskMerch() }"
      >
        <fa-icon
          (click)="onEditorOpen()"
          [icon]="['fas', 'pencil']"
          class="icon paperclip"
        ></fa-icon>
      </div>
    </div>
    <div class="right-buttons">
      <div
        [ngClass]="{ 'comment-sender__button_disabled': formStatus.loading }"
        class="comment-sender__button"
      >
        <div (click)="send(message)" class="icon-wrapper">
          <ng-container *ngIf="!formStatus.loading; else loading">
            <div>
              <fa-icon [icon]="['far', 'paper-plane']" class="icon"></fa-icon>
            </div>
          </ng-container>
          <ng-template #loading>
            <div class="comments__loading">
              <fa-icon [icon]="['fas', 'spinner']" [spin]="true" class="tr-spin"></fa-icon>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isAllowCreateTask" class="right-buttons__block">
    <input
      (change)="onCheckedSetTaskMerch($event)"
      [checked]="isCheckedSetTaskMerch()"
      type="checkbox"
    />
    <!-- <app-checkbox
      isHoverAnimation="false"
      (changed)="onCheckedSetTaskMerch($event)"
      [ngModel]="isCheckedSetTaskMerch()"
    ></app-checkbox> -->
    <span>Поставить задачу мерчандайзеру</span>
  </div>
</div>

<dx-popup
  #popup
  (onHidden)="closePhotoReplacerModal()"
  *ngIf="showPhotoReplacerModal"
  [dragEnabled]="true"
  [fullScreen]="true"
  [height]="500"
  [showTitle]="true"
  [title]="'Фото'"
  [visible]="showPhotoReplacerModal"
  [width]="450"
  class="popup"
  container="#containerElement"
>
  <app-photo-report-replacer-gallery
    (photoChange)="onPhotoChange($event, popup)"
    [photos]="photos()"
  ></app-photo-report-replacer-gallery>
</dx-popup>
